module.exports = __webpack_public_path__ + "static/media/føde.78006ae4.m4a";